import React, { useEffect, useState } from 'react';
import {
  onSave,
  refinePayload,
  useNotification,
  fieldValidation,
  getDialogHeading,
  showBackdropLoader,
  dropDownValidation,
  renderSaveCancelButtons,
} from 'utils/commonUtils';
import * as yup from 'yup';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { GridForm } from 'components/Ui/styled';
import { yupResolver } from '@hookform/resolvers/yup';
import { PaperProps, characterLimit, tutorSubjectSuccess } from 'constants';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import FormInputDropdown from 'components/Common/Forms/FormInputDropDown';
import {
  postTutoringSubject,
  putTutoringSubject,
} from 'layouts/tutoring/services/tutoringApi';

const subjectsAndTurorsSchema = yup.object().shape({
  name: fieldValidation(characterLimit),
  tutorId: dropDownValidation,
});

const SubjectsAndTurorsDialog = (props) => {
  const {
    open,
    setOpen,
    newSubject,
    setNewSubject,
    isFormLoading,
    tutoringSubjectForm,
    fetchTutoringSubjects,
    setTutoringSubjectForm,
  } = props;

  const availableUsersList =
    useSelector((state) => state?.availableUsersList) || {};

  const [loadingButton, setLoadingButton] = useState(false);
  const { name, tutorId, subjectId } = tutoringSubjectForm || {};

  const defaultValue = {
    name: name || '',
    tutorId: tutorId || '',
  };

  const { setOpenNotification, setNotificationMessage, NotificationPopup } =
    useNotification();
  const dispatch = useDispatch();

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(subjectsAndTurorsSchema),
  });

  const { handleSubmit, reset, control, formState } = useFunction;
  const { errors } = formState;

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
    setTutoringSubjectForm(null);
  };

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.name, defaultValue.tutorId]);

  const tutorsList = availableUsersList?.map((item, index) => ({
    id: item?.userId,
    value: `${item?.givenName} ${item?.familyName}` || item?.username,
  }));

  const onSubmit = async (data) => {
    const { name, tutorId } = data;
    const payload = { name, tutorId };

    onSave(
      tutorSubjectSuccess,
      newSubject,
      postTutoringSubject,
      putTutoringSubject,
      refinePayload(payload),
      subjectId,
      fetchTutoringSubjects,
      handleClose,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setLoadingButton
    );
    setNewSubject(false);
  };

  return (
    <>
      {showBackdropLoader(isFormLoading)}
      <Dialog open={open} PaperProps={PaperProps}>
        {getDialogHeading('Subjects & Tutors', handleClose)}

        <GridForm container spacing={2}>
          <Grid item xs={12} sm={11.2}>
            <FormInputText
              name="name"
              type="text"
              control={control}
              required={true}
              label="Name"
              helperText={errors?.name?.message}
              errors={!!errors.name}
            />
          </Grid>
          <Grid item xs={12} sm={11.2}>
            <FormInputDropdown
              name="tutorId"
              type="text"
              control={control}
              options={tutorsList}
              label="Tutor"
              helperText={errors?.tutorId?.message}
              errors={!!errors.tutorId}
            />
          </Grid>
          {renderSaveCancelButtons(
            handleClose,
            handleSubmit(onSubmit),
            loadingButton
          )}
        </GridForm>
        <NotificationPopup />
      </Dialog>
    </>
  );
};

export default SubjectsAndTurorsDialog;
